
// import { addToCart } from "../features/cart/cartSlice";
import { useSelector } from "react-redux";
import foodImg1 from "../assets/img/1.jpg";
import foodImg2 from "../assets/img/2.jpg";
import foodImg3 from "../assets/img/3.jpg";

const Home = () => {
  const user = useSelector((state) => state.auth.user);
  console.log(user);

  return (
    <>
    <div className="container-fluid home-container-banner d-flex align-items-center justify-content-center vh-100">
      <div className="container">
        <div className="row">
          <div className="col-md-12 mb-3">
            {user?(
              <h3>Hi {user.name}</h3>
                
            ):(
              <h3>Hey Please Login</h3>
            )}
            <h4>Your Food Is Waiting For You</h4>
            <p>Your Food Is Waiting For YouYour Food Is Waiting For YouYour Food Is Waiting For YouYour Food Is Waiting For You</p>
          </div>
          <div className="col-md-3 mb-4">
            <div className="card h-100 shadow-sm">
              
              <img
                src={foodImg1}
                className="card-img-top"
                alt="food"
              />

              <div className="card-body d-flex flex-column">
                <h5 className="card-title">Pizza</h5>
                <p className="card-text text-muted mb-2">
                  Delicious cheesy pizza with toppings
                </p>

              </div>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="card h-100 shadow-sm">
              
              <img
                src={foodImg2}
                className="card-img-top"
                alt="food"
              />

              <div className="card-body d-flex flex-column">
                <h5 className="card-title">Pizza</h5>
                <p className="card-text text-muted mb-2">
                  Delicious cheesy pizza with toppings
                </p>

              </div>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="card h-100 shadow-sm">
              
              <img
                src={foodImg3}
                className="card-img-top"
                alt="food"
              />

              <div className="card-body d-flex flex-column">
                <h5 className="card-title">Pizza</h5>
                <p className="card-text text-muted mb-2">
                  Delicious cheesy pizza with toppings
                </p>

              </div>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="card h-100 shadow-sm">
              
              <img
                src={foodImg2}
                className="card-img-top"
                alt="food"
              />

              <div className="card-body d-flex flex-column">
                <h5 className="card-title">Pizza</h5>
                <p className="card-text text-muted mb-2">
                  Delicious cheesy pizza with toppings
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {user?(
      <div className="container">
        <div className="row">
            <div className="col-md-3">1</div>
        </div>
      </div>):(
      <p></p>
    )}
    </>
  );
};

export default Home;